var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrev = function SvgPrev(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.082 4.739 4.46 4.282a.273.273 0 0 0 .379 0 .25.25 0 0 0 0-.364L.649 4.558 4.921.46a.25.25 0 0 0 0-.363.275.275 0 0 0-.189-.076.264.264 0 0 0-.188.076L.082 4.378a.248.248 0 0 0 0 .36"
  })));
};
export default SvgPrev;